import { render, staticRenderFns } from "./scoreLine.vue?vue&type=template&id=2f37de56&scoped=true&"
import script from "./scoreLine.vue?vue&type=script&lang=js&"
export * from "./scoreLine.vue?vue&type=script&lang=js&"
import style0 from "./scoreLine.vue?vue&type=style&index=0&id=2f37de56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f37de56",
  null
  
)

export default component.exports